const FAQS = [
  {
    q: "What does the 26–40% estimated ROI actually mean?",
    a: "The estimated annual ROI reflects modelled net returns from our managed hospitality network — combining nightly rental income, event bookings and occupancy across the year. It is an indicative figure based on projected demand and operating costs, so actual returns can vary by location, seasonality and management fees.",
  },
  {
    q: "What are my revenue model options?",
    a: "You can choose between a Profit Sharing Model, where returns move with resort performance and carry higher upside, or a Minimum Rental Model, which guarantees a fixed annual income for predictable, lower-risk cash flow. Both are professionally structured.",
  },
  {
    q: "How do payments and staged instalments work?",
    a: "Most buyers opt for construction-linked payments, so your capital is deployed gradually as the build progresses rather than upfront. This spreads your exposure and lets you plan cash flow around each construction milestone.",
  },
  {
    q: "Who manages the villa once I buy it?",
    a: "Our professional hospitality team handles bookings, maintenance, housekeeping, guest experience and marketing across Airbnb, Booking.com and direct channels. You collect returns with zero day-to-day hassle.",
  },
  {
    q: "Can I still use the villa myself?",
    a: "Yes. Your villa is also your holiday home. You get personal usage whenever you like, and the asset simply goes back into the managed rental pool during the rest of the year.",
  },
  {
    q: "What are my exit options?",
    a: "We offer liquidity-friendly paths to sell or exit your investment when the time is right, including direct resale, co-ownership transfer and structured buyback discussions, giving you flexibility over your capital.",
  },
];

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function PricingFaq() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(FAQ_SCHEMA) }}
      />
      <section className="w-full py-12 md:py-16 bg-background-100">
        <div className="w-full px-4 md:px-8 max-w-4xl mx-auto">
          <div className="text-center max-w-2xl mx-auto">
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-question-line"></i> Pricing &amp; Returns FAQ
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-4 leading-tight">
              Your Questions, <span className="italic text-primary-700">Answered</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
              Everything you need to know about villa pricing, returns and ownership before you
              make a decision.
            </p>
          </div>

          <div className="mt-10 space-y-3 md:space-y-4">
            {FAQS.map((item) => (
              <details
                key={item.q}
                className="group rounded-2xl bg-background-50 border border-background-200 open:border-primary-300 transition-colors"
              >
                <summary className="flex items-center justify-between gap-4 cursor-pointer px-5 md:px-6 py-4 md:py-5 list-none">
                  <h4 className="text-sm md:text-base font-bold text-foreground-950 leading-snug">
                    {item.q}
                  </h4>
                  <span className="flex items-center justify-center w-7 h-7 rounded-full bg-secondary-100 text-secondary-900 shrink-0 group-open:bg-primary-100 group-open:text-primary-700 transition-colors">
                    <i className="ri-add-line text-lg group-open:rotate-45 transition-transform"></i>
                  </span>
                </summary>
                <p className="px-5 md:px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}